module.exports = __webpack_public_path__ + "static/media/layers.793f695a.svg";